import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasParentProductId, withParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import translate from "@insite/client-framework/Translate";
import {
    AvailabilityDto,
    BadgeModel,
    ProductModel,
    RealTimeInventoryModel,
    RealTimePricingModel,
} from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import DataTable from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import QuestionCircle from "@insite/mobius/Icons/QuestionCircle";
import { DataTableCell, DataTableHead, LoadingSpinner, Tooltip, Typography } from "@insite/mobius/index";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductAvailabilityInfoIcon from "@tSurya/Icons/ProductAvailabilityInfoIcon";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { iteratorSymbol } from "immer/dist/internal";
import React, { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";


interface OwnProps {
    childVarients?: ProductModel[];
    // productIds: string[];
}

const mapStateToProps = (state: ApplicationState) => ({
    isAuthenticated: state.context.session.isAuthenticated,
    productPriceData: state.pages.productDetails.productInfosById,
});

const mapDispatchToProps = {
    loadRealTimePricing,
    loadRealTimeInventory,
};

type Props = OwnProps &
    ResolveThunks<typeof mapDispatchToProps> &
    ReturnType<typeof mapStateToProps> &
    HasParentProductId;

export interface AvailibilityTableStlyes {
    container?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    tableHeadContaner?: DataTableHeadProps;
    tableBody?: DataTableBodyProps;
    noborder?: DataTableCellProps;
    border?: DataTableCellProps;
    priceStyles?: DataTableCellProps;
    eTAStyles?: InjectableCss;
    msgStyles?: InjectableCss;
    iconStyle?: InjectableCss;
    transitMessage?: InjectableCss;
    productionMessage?: InjectableCss;
    copyBtn?: ButtonPresentationProps;
    dimensions?: InjectableCss;
    shippingWeightStyles?: InjectableCss;
    shippingDimesionStyles?: InjectableCss;
    circleIcon?: InjectableCss;
    circleIconDays?: InjectableCss;
    clearanceStyle?:InjectableCss;
}

const AvailibilityTableStlyes: AvailibilityTableStlyes = {
    shippingWeightStyles: {
        css: css`
            text-align: center !important;
            border: 1px solid ${getColor("common.border")} !important;
            position: relative;
            line-height: 20px;
        `,
    },
    circleIconDays: {
        css: css`
            position: relative;
            top: 20px;
            right: 0px;
        `,
    },
    circleIcon: {
        css: css`
            position: relative;
            top: 20px;
            right: 0px;
        `,
    },
    shippingDimesionStyles: {
        css: css`
            text-align: center !important;
            border: 1px solid ${getColor("common.border")} !important;
            position: relative;
            line-height: 20px;
        `,
    },
    container: {
        css: css`
            padding: 20px;
            width: 100%;
            overflow: auto;
        `,
    },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    tableHeadContaner: {
        css: css`
            th {
                line-height: ${TYPOGRAPHY.lineHeight.xbase};
                color: ${getColor("text.main")};
                font-size: ${TYPOGRAPHY.size.base};
                font-weight: ${TYPOGRAPHY.weight.bold};
                padding: 20px 10px;
                position: relative;
                span {
                    font-size: ${TYPOGRAPHY.size.base};
                    font-weight: ${TYPOGRAPHY.weight.bold};
                }
            }
        `,
    },
    tableBody: {
        css: css`
            tr {
                background-color: ${getColor("primary.contrast")} !important;
            }
            span {
                font-size: ${TYPOGRAPHY.size.smaller};
                font-weight: ${TYPOGRAPHY.weight.base};
            }
        `,
    },
    noborder: {
        css: css`
            border: 0 !important;
            border-bottom: 1px solid ${getColor("common.border")} !important;
            &:last-of-type {
                border-right: 1px solid ${getColor("common.border")} !important;
            }
            position: relative;
        `,
    },
    border: {
        css: css`
            border: 1px solid ${getColor("common.border")} !important;
            position: relative;
            line-height: 20px;
        `,
    },
    priceStyles: {
        css: css`
            span {
                font-size: ${TYPOGRAPHY.size.base};
                font-weight: ${TYPOGRAPHY.weight.bold};
                line-height: ${TYPOGRAPHY.lineHeight.xbase};
            }
        `,
    },
    eTAStyles: {
        css: css`
            background: ${getColor("common.backgroundContrast")};
            padding: 1px 8px;
            margin-left: 10px;
            display: inline-block;
            position: relative;
        `,
    },
    iconStyle: {
        css: css`
            display: flex;
            > div {
                padding-left: 5px;
                height: fit-content;
                &:hover {
                    > span {
                        display: inline-block;
                    }
                }
            }
        `,
    },
    transitMessage: {
        css: css`
            display: none;
            position: absolute;
            right: -57px;
           background: #323132;
            padding: 5px 10px;
            border-radius: 4px;
            z-index: 99;
            font-size: 12px !important;
            color: white;
            font-weight: 600 !important;
            top: -40px;
            white-space: nowrap;
        `,
    },
    productionMessage: {
        css: css`
            display: none;
            position: absolute;
            right:  13px;
           background: #323132;
            padding: 5px 10px;
            border-radius: 4px;
            z-index: 99;
            font-size: 12px !important;
            color: white;
            font-weight: 600 !important;
            top: -40px;
            white-space: nowrap;
        `,
    },
    msgStyles: {
        css: css`
            background: ${getColor("text.main")};
            padding: 1px 8px;
            color: ${getColor("primary.contrast")};
            position: absolute;
            bottom: -25px;
            font-size: 12px;
            left: 50%;
            transform: translate(-50%);
            ::after {
                content: "";
                position: absolute;
                left: 50%;
                transform: translate(-50%);
                top: -8px;
                width: 0;
                height: 0;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-bottom: 8px solid ${getColor("text.main")};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        // right: -5%;
                    `,
                    css`
                        //right: -5%;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    copyBtn: {
        css: css`
            position: absolute;
            top: 9px;
            min-height: 37px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        right: 15%;
                    `,
                    css`
                        right: 15%;
                    `,
                    css`
                        right: 7%;
                    `,
                    css`
                        right: 5%;
                    `,
                    css`
                        right: 5%;
                    `,
                ])}
        `,
    },

    dimensions: {
        css: css`
            line-height: 20px;
            text-align: left;
        `,
    },
    clearanceStyle:{
        css:css`
        background-color: #A93327;
        color: #FFFFFF; 
        display: flex; 
        justify-content: center; 
        align-items: center; 
        margin-top:2px;
        padding:0 10px;
        `
    },
};

const styles = AvailibilityTableStlyes;

const ProductAvailibiltyTable = ({
    loadRealTimePricing,
    loadRealTimeInventory,
    childVarients,
    isAuthenticated,
    productPriceData,
}: Props) => {
    // const [realTimePricingData, setRealTimePricingData] = React.useState<RealTimePricingModel>();
    // const [realTimeInventoryData, setRealTimeInventoryData] = React.useState<RealTimeInventoryModel>();
    const [productDataStock, setProductDataStock] = React.useState<any[]>([]);
    const [q30msgState, setQ30MsgState] = React.useState<number | null>(null);
    const [q60MsgState, setQ60MsgState] = React.useState<number | null>(null);
    const [q90MsgState, setq90MsgState] = React.useState<number | null>(null);
    const toasterContext = useContext(ToasterContext);
    React.useEffect(() => {
        const productStockObjData: any[] = [];

        const productStockObj =
            !!productPriceData &&
            childVarients?.forEach((item, index) => {
                const clearanceAttributeType = item.attributeTypes?.find(
                    (attrType) => attrType.name === "Clearance" || attrType.label === "Clearance"
                );
                const isClearanceValue = clearanceAttributeType?.attributeValues?.some(({ value }) => value === "Yes");

                productStockObjData.push({
                    title: item.productNumber,
                    Clearance: isClearanceValue,
                    size: item.childTraitValues?.length ? item.childTraitValues[0].valueDisplay : "",
                    dimensions: Carton2Dimensions(item),
                    weight: Carton2Weight(item),
                    inStock: productPriceData ? productPriceData[item.id]?.inventory?.additionalResults?.qCapped : null,
                    inStock30: productPriceData
                        ? productPriceData[item.id]?.inventory?.additionalResults?.q30Capped
                        : null,
                    inStock60: productPriceData
                        ? productPriceData[item.id]?.inventory?.additionalResults?.q60Capped
                        : null,
                    inStockOver60: productPriceData
                        ? productPriceData[item.id]?.inventory?.additionalResults?.q90Capped
                        : null,
                    quantity30Msg: productPriceData
                        ? productPriceData[item.id]?.inventory?.additionalResults?.q30Msg
                        : null,
                    quantity60Msg: productPriceData
                        ? productPriceData[item.id]?.inventory?.additionalResults?.q60Msg
                        : null,
                    quantity90Msg: productPriceData
                        ? productPriceData[item.id]?.inventory?.additionalResults?.q90Msg
                        : null,
                    price:
                        productPriceData && isAuthenticated
                            ? productPriceData[item.id]?.pricing?.actualPriceDisplay
                            : "",
                    quoteRequiredProduct:
                        item.productNumber.toLowerCase().endsWith("-cstd") ||
                        item.productNumber.toLowerCase().endsWith("-cexp") ||
                        item.productNumber.toLowerCase().endsWith("-custom"),
                    quoteType: item.productNumber.toLowerCase().endsWith("-cstd")
                        ? "Custom (Standard)"
                        : item.productNumber.toLocaleLowerCase().endsWith("-cexp")
                        ? "Custom (Expedited)"
                        : "Custom",
                    madeToOrder: productPriceData[item.id]?.inventory?.inventoryAvailabilityDtos?.find(o => {
                        if (o.availability?.message === "Made to Order") {
                            return true;
                        }
                        return false;
                    }),
                });
            });
        setProductDataStock(productStockObjData);

    }, [productPriceData]);

    const ShowClearance = (<StyledWrapper style={{display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center'}}>
        <StyledWrapper {...styles.clearanceStyle}>
            <span style={{ fontSize: '10px', lineHeight: '1.3' }}>CLEARANCE</span>
        </StyledWrapper>
    </StyledWrapper>);

    function handleCopyClick() {
        const table = document.querySelector(".availibility-table") as HTMLTableElement;
        const range = document.createRange();
        range.selectNode(table);
        window.getSelection()?.removeAllRanges();
        window.getSelection()?.addRange(range);
        const success = document.execCommand("copy");
        window.getSelection()?.removeAllRanges();
        if (success) {
            toasterContext.addToast({
                body: translate("Table copied to clipboard!"),
                messageType: "success",
                timeoutLength: 3500,
            });
        } else {
            toasterContext.addToast({
                body: translate("Copy operation failed."),
                messageType: "danger",
                timeoutLength: 3500,
            });
        }
    }

    function Carton2Dimensions(item: ProductModel) {
        const itemShippingLengthCarton2 = item.properties?.itemShippingLengthCarton2;
        const itemShippingWidthCarton2 = item.properties?.itemShippingWidthCarton2;
        const itemShippingHeightCarton2 = item.properties?.itemShippingHeightCarton2;
        const itemShippingLengthCarton3 = item.properties?.itemShippingLengthCarton3;
        const itemShippingWidthCarton3 = item.properties?.itemShippingWidthCarton3;
        const itemShippingHeightCarton3 = item.properties?.itemShippingHeightCarton3;
        const html = (
            <>
                {ValidateCartonDimensions(
                    itemShippingLengthCarton2,
                    itemShippingWidthCarton2,
                    itemShippingHeightCarton2,
                ) ||
                ValidateCartonDimensions(
                    itemShippingLengthCarton3,
                    itemShippingWidthCarton3,
                    itemShippingHeightCarton3,
                ) ? (
                    <Typography
                        {...styles.dimensions}
                        css={css`
                            text-align: left;
                            display: block;
                            width: 100%;
                        `}
                    >
                        {`Carton 1: ${item.detail?.shippingLength}"L x ${item.detail?.shippingWidth}"W x ${item.detail?.shippingHeight}"H`}
                    </Typography>
                ) : (
                    <Typography>
                        {`${item.detail?.shippingLength}"L x ${item.detail?.shippingWidth}"W x ${item.detail?.shippingHeight}"H`}
                    </Typography>
                )}
                {ValidateCartonDimensions(
                    itemShippingLengthCarton2,
                    itemShippingWidthCarton2,
                    itemShippingHeightCarton2,
                ) && (
                    <Typography
                        {...styles.dimensions}
                        css={css`
                            text-align: left;
                            display: block;
                            width: 100%;
                        `}
                    >
                        {`Carton 2: ${itemShippingLengthCarton2}"L x ${itemShippingWidthCarton2}"W x ${itemShippingHeightCarton2}"H`}
                    </Typography>
                )}
                {ValidateCartonDimensions(
                    itemShippingLengthCarton3,
                    itemShippingWidthCarton3,
                    itemShippingHeightCarton3,
                ) && (
                    <Typography
                        {...styles.dimensions}
                        css={css`
                            text-align: left;
                            display: block;
                            width: 100%;
                        `}
                    >
                        {`Carton 3: ${itemShippingLengthCarton3}"L x ${itemShippingWidthCarton3}"W x ${itemShippingHeightCarton3}"H`}
                    </Typography>
                )}
            </>
        );
        return html;
    }
    function ValidateCartonDimensions(length: string, width: string, height: string) {
        if (Number(length) !== 0 && Number(width) !== 0 && Number(height) !== 0 && length && width && height) {
            return true;
        }

        return false;
    }

    function Carton2Weight(item: ProductModel) {
        const weight = `${item.detail?.shippingWeight} lbs`;
        const carton2Weight = item.properties.itemShippingWeightCarton2;
        const carton3Weight = item.properties.itemShippingWeightCarton3;
        const html = (
            <>
                {(carton2Weight && Number(carton2Weight) !== 0) || (carton3Weight && Number(carton3Weight) !== 0) ? (
                    <Typography
                        css={css`
                            text-align: left;
                            display: block;
                            width: 100%;
                        `}
                    >{`Carton 1: ${weight}`}</Typography>
                ) : (
                    <Typography>{weight}</Typography>
                )}
                {carton2Weight && Number(carton2Weight) !== 0 && (
                    <Typography
                        css={css`
                            text-align: left;
                            display: block;
                            width: 100%;
                        `}
                    >{`Carton 2: ${carton2Weight} lbs`}</Typography>
                )}
                {carton3Weight && Number(carton3Weight) !== 0 && (
                    <Typography
                        css={css`
                            text-align: left;
                            display: block;
                            width: 100%;
                        `}
                    >{`Carton 3: ${carton3Weight} lbs`}</Typography>
                )}
            </>
        );
        return html;
    }

    return (
        <StyledWrapper {...styles.container}>
            {!(productDataStock.length > 0) || (isAuthenticated && !(productDataStock.length > 0)) ? (
                <StyledWrapper {...styles.centeringWrapper}>
                    {/* <LoadingSpinner {...styles.spinner} /> */}
                    <Typography
                        css={css`
                            font-size: ${TYPOGRAPHY.size.base};
                            font-weight: ${TYPOGRAPHY.weight.bold};
                            width: 100%;
                            text-align: center;
                        `}
                    >
                        No Data Found
                    </Typography>
                </StyledWrapper>
            ) : (
                <>
                    <Button {...styles.copyBtn} onClick={handleCopyClick}>
                        {translate("Copy")}
                    </Button>
                    <DataTable className="availibility-table">
                        <DataTableHead {...styles.tableHeadContaner}>
                            <DataTableHeader>{translate("Sizes")}</DataTableHeader>
                            <DataTableHeader>Item (SKU)</DataTableHeader>
                            <DataTableHeader>Shipping Dimensions</DataTableHeader>
                            <DataTableHeader>Shipping Weight</DataTableHeader>
                            <DataTableHeader>Quantity in Stock</DataTableHeader>
                            <DataTableHeader>
                                <Typography as="div" {...styles.iconStyle}>
                                    Quantity Within 30 Days{" "}
                                    <Typography as="div" {...styles.circleIconDays}>
                                        <QuestionCircle src={ProductAvailabilityInfoIcon} />{" "}
                                        <Typography as="span" {...styles.transitMessage}>
                                            In Transit
                                        </Typography>{" "}
                                    </Typography>{" "}
                                </Typography>
                            </DataTableHeader>
                            <DataTableHeader>
                                <Typography as="div" {...styles.iconStyle}>
                                    {" "}
                                    Quantity Within 2 Months{" "}
                                    <Typography as="div" {...styles.circleIcon}>
                                        <QuestionCircle src={ProductAvailabilityInfoIcon} />{" "}
                                        <Typography as="span" {...styles.transitMessage}>
                                            In Transit
                                        </Typography>{" "}
                                    </Typography>{" "}
                                </Typography>
                            </DataTableHeader>
                            <DataTableHeader>
                                <Typography as="div" {...styles.iconStyle}>
                                    {" "}
                                    Quantity Over 2 Months{" "}
                                    <Typography as="div" {...styles.circleIcon}>
                                        <QuestionCircle src={ProductAvailabilityInfoIcon} />{" "}
                                        <Typography as="span" {...styles.productionMessage}>
                                            In Production
                                        </Typography>{" "}
                                    </Typography>{" "}
                                </Typography>
                            </DataTableHeader>
                            {isAuthenticated && !!productPriceData && <DataTableHeader>Price</DataTableHeader>}
                        </DataTableHead>
                        <DataTableBody {...styles.tableBody}>
                            {productDataStock.length > 0 &&
                                productDataStock.map((item, index) => {
                                    return (
                                        <DataTableRow key={item.title}>
                                            <DataTableCell>
                                                {item.quoteRequiredProduct ? item.quoteType : item.size}
                                                {item.Clearance ? ShowClearance : ""}
                                            </DataTableCell>
                                            <DataTableCell>{item.title}</DataTableCell>
                                            {item.quoteRequiredProduct || item.madeToOrder ? (
                                                <DataTableCell colSpan={6}>{translate("Made to Order")}</DataTableCell> 
                                            ) : (
                                                <>
                                                    <DataTableCell
                                                        {...(item.quoteRequiredProduct
                                                            ? styles.noborder
                                                            : styles.shippingDimesionStyles)}
                                                    >
                                                        {item.quoteRequiredProduct ? "" : item.dimensions}
                                                    </DataTableCell>
                                                    <DataTableCell
                                                        {...(item.quoteRequiredProduct
                                                            ? styles.noborder
                                                            : styles.shippingWeightStyles)}
                                                    >
                                                        {item.quoteRequiredProduct ? "" : item.weight}
                                                    </DataTableCell>
                                                    <DataTableCell
                                                        {...(item.quoteRequiredProduct || item.madeToOrder
                                                            ? styles.noborder
                                                            : styles.border)}
                                                    >
                                                        {item.quoteRequiredProduct || item.madeToOrder
                                                            ? ""
                                                            : item.inStock}
                                                    </DataTableCell>
                                                    <DataTableCell
                                                        {...(item.quoteRequiredProduct || item.madeToOrder
                                                            ? styles.noborder
                                                            : styles.border)}
                                                    >
                                                        {item.quoteRequiredProduct || item.madeToOrder
                                                            ? ""
                                                            : item.inStock30}
                                                        {item.quantity30Msg !== "" && (
                                                            <Typography
                                                                {...styles.eTAStyles}
                                                                onMouseOver={() => {
                                                                    setQ30MsgState(index);
                                                                }}
                                                                onMouseOut={() => setQ30MsgState(null)}
                                                            >
                                                                {item.madeToOrder ? "" : <>ETA</>}
                                                                {q30msgState === index && item.quantity30Msg && (
                                                                    <StyledWrapper {...styles.msgStyles}>
                                                                        {item.quantity30Msg}
                                                                    </StyledWrapper>
                                                                )}
                                                            </Typography>
                                                        )}
                                                    </DataTableCell>
                                                    <DataTableCell
                                                        {...(item.quoteRequiredProduct || item.madeToOrder
                                                            ? styles.noborder
                                                            : styles.border)}
                                                    >
                                                        {item.quoteRequiredProduct || item.madeToOrder
                                                            ? ""
                                                            : item.inStock60}
                                                        {item.quantity60Msg !== "" && (
                                                            <Typography
                                                                {...styles.eTAStyles}
                                                                onMouseOver={() => {
                                                                    setQ60MsgState(index);
                                                                }}
                                                                onMouseOut={() => setQ60MsgState(null)}
                                                            >
                                                                {item.madeToOrder ? "" : <>ETA</>}
                                                                {q60MsgState === index && item.quantity60Msg && (
                                                                    <StyledWrapper {...styles.msgStyles}>
                                                                        {item.quantity60Msg}
                                                                    </StyledWrapper>
                                                                )}
                                                            </Typography>
                                                        )}
                                                    </DataTableCell>
                                                    <DataTableCell
                                                        {...(item.quoteRequiredProduct || item.madeToOrder
                                                            ? styles.noborder
                                                            : styles.border)}
                                                    >
                                                        {item.quoteRequiredProduct || item.madeToOrder
                                                            ? ""
                                                            : item.inStockOver60}
                                                        {item.quantity90Msg !== "" && (
                                                            <Typography
                                                                {...styles.eTAStyles}
                                                                onMouseOver={() => {
                                                                    setq90MsgState(index);
                                                                }}
                                                                onMouseOut={() => setq90MsgState(null)}
                                                            >
                                                                {item.madeToOrder ? "" : <>ETA</>}
                                                                {q90MsgState === index && item.quantity90Msg && (
                                                                    <StyledWrapper {...styles.msgStyles}>
                                                                        {item.quantity90Msg}
                                                                    </StyledWrapper>
                                                                )}
                                                            </Typography>
                                                        )}
                                                    </DataTableCell>
                                                    
                                                </>
                                            )}
                                            {isAuthenticated && (
                                                        <DataTableCell {...styles.priceStyles}>
                                                            {item.price}{" "}
                                                            {item.quoteRequiredProduct ? translate("psf") : null}
                                                        </DataTableCell>
                                                    )}
                                        </DataTableRow>
                                    );
                                })}
                        </DataTableBody>
                    </DataTable>
                </>
            )}
        </StyledWrapper>
    );
};

export default withParentProductId(connect(mapStateToProps, mapDispatchToProps)(ProductAvailibiltyTable));
